import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatSelectModule} from "@angular/material/select";
import {ReactiveFormsModule} from "@angular/forms";
import {MembersSelectComponent} from "./members-select.component";



@NgModule({
  declarations: [MembersSelectComponent],
  imports: [
    CommonModule,
    MatSelectModule,
    ReactiveFormsModule
  ],
  exports: [MembersSelectComponent]
})
export class MembersSelectModule { }
